import { createModel } from 'xstate/lib/model';

import baseEvents from 'common/bento/config/baseEvents';
import { ApplicantType } from 'features/Onboarding/types';

type ComplianceAndPersonalAddressModuleData = {
  companyProfileId: string;
  applicantType: ApplicantType;
};

export type Context = {
  getModuleData: () => ComplianceAndPersonalAddressModuleData;
};

const initialContext: Context = {
  getModuleData: () => {
    throw new Error('NOT_IMPLEMENTED');
  },
};

const model = createModel(
  initialContext,

  {
    events: {
      ...baseEvents,
    },
  },
);

export default model;
